<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-31 16:49:41
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-27 20:43:44
 * @FilePath: /dsicm-admin-web/src/views/questionnaire/src/index/index.vue
-->
<template>
    <div class="content">
        <header class="header">
            <el-button size="mini" type="primary" @click="dialogFormVisible = !dialogFormVisible">创建问卷</el-button>
        </header>
      
       <BaseTable
        size="mini"
        border
        stripe
        :data="homeTableQuerr.listData"
        :column="homeConfig"
        pagination
        :auto-scroll="true"
        :total="homeTableQuerr.totalPage"
        :page.sync="homeTableQuerr.listQuery.current"
        :limit.sync="homeTableQuerr.listQuery.size"
        @pagination="paginationChange">
      </BaseTable>
        <!-- 创建问卷 -->
        <el-dialog 
        title="创建问卷"
        :close-on-click-modal="false"
        @close="closeissue"
        center
        :visible.sync="dialogFormVisible">
            <el-form ref="forms" :model="addForm" label-width="100px" label-position="left"  :rules="formRules">
                <el-form-item label="标题" prop="title">
                    <el-input 
                    v-model="addForm.title"
                    placeholder="请输入问卷标题" 
                    autocomplete="off"></el-input>
                </el-form-item>
                 <el-form-item label="副标题" prop="subTitle">
                    <el-input 
                    v-model="addForm.subTitle"
                    placeholder="请输入问卷副标题" 
                    autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label='问卷类型' prop="tagName">
                <el-select 
                v-model="addForm.tagName" 
                clearable 
                placeholder="请选择">
                  <el-option 
                  v-for="item in tagNameTypeList" 
                  :key="item.id" 
                  :label="item.name" 
                  :value="item.name"> 
                  </el-option>
                </el-select>
              </el-form-item> 
                <el-form-item label="说明" prop="note">
                    <el-input 
                        v-model="addForm.note" 
                        type="textarea" 
                        maxlength="30"
                        placeholder="添加问卷说明"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="问卷封面图" required>
                    <BaseUploadFile 
                    :isShowTip="false" 
                    :size="100" 
                    :responseFn="handleBackgroundResponse" 
                    action="/api/dsicm-contact-platform/feign/file/upload" 
                    :data="{ path: 'dsicm-doctor' }" 
                    v-model="addForm.image">
                    </BaseUploadFile>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addNew">立即创建</el-button>
            </div>
        </el-dialog>
        
        <!-- 预览问卷弹窗 -->
        <PreviewDialog
        ref="dialogRef"
        :paramData="paramData">
        </PreviewDialog>
        <!-- 推送弹窗 -->
        <!-- 推送病人选择 -->
          <el-dialog
            width="80%"
            title="病人选择"
            top="5vh"
            center
            :visible.sync="pushDiaog"
            v-if="pushDiaog"
            @close="closePushDiaog"
            append-to-body>
            <el-form inline size="mini"> 
              <el-form-item>
                <el-input 
                placeholder="请输入要搜索的内容" 
                prefix-icon="el-icon-search"
                v-model="searchPatientData.listQuery.redundant" >
                </el-input>
              </el-form-item>  
              <el-form-item label="疾病类型:">
                <el-select 
                v-model="searchPatientData.listQuery.diseaseType" 
                clearable 
                placeholder="请选择">
                  <el-option 
                  v-for="(item, index) in diseaseTypeList" 
                  :key="index" 
                  :label="item.suborderName" 
                  :value="item.suborderName"> 
                  </el-option>
                </el-select>
              </el-form-item>  
              <el-form-item  label='病人类型:'>
                <el-select 
                v-model="searchPatientData.listQuery.userType" 
                clearable 
                placeholder="请选择">
                  <el-option 
                  v-for="item in userTypeList" 
                  :key="item.value" 
                  :label="item.label" 
                  :value="item.label"> 
                  </el-option>
                </el-select>
              </el-form-item> 
              <el-form-item label="来源渠道">
                <el-select 
                v-model="searchPatientData.listQuery.userFrom" 
                clearable 
                placeholder="请选择">
                  <el-option 
                  v-for="item in userFromList" 
                  :key="item.value" 
                  :label="item.label" 
                  :value="item.label"> 
                  </el-option>
                </el-select>
              </el-form-item>  
              
              <el-form-item>
                <el-button type="primary" size="mini" @click="resetquerySearchPatient">重置</el-button>
                <el-button type="primary" size="mini" @click="querySearchPatient">搜索</el-button>
              </el-form-item>
            </el-form>
            <div style="height:50vh">
              <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
                <BaseTable
                  ref="multipleTable"
                  size="mini"
                  border
                  stripe
                  :data="searchPatientData.listData"
                  :column="pushConfig"
                  pagination
                  :auto-scroll="true"
                  :total="searchPatientData.totalPage"
                  :page.sync="searchPatientData.listQuery.current"
                  :limit.sync="searchPatientData.listQuery.size"
                  @selection-change="pushListChange"
                  @pagination="queryPushList">
                </BaseTable>
              </el-scrollbar>
            </div>
            <span slot="footer">
                <el-button type="primary" size="mini" :loading="loadingFlag" @click="qushSearchPatient">推送</el-button>
            </span>
          </el-dialog>
    </div>
    
</template>
<script>
import homeTableConfig from '../../common/index'
import PreviewDialog from '../../components/index';
import { diseaseType } from '@/api/doctorTeam'
import {addExam , list ,selectListExam , passQuestion ,searchPatient ,pushIm } from '../../api'
export default {
    name:'questionManager',
    mixins:[homeTableConfig],
    components:{
        PreviewDialog
    },
    data(){
        return{
            loadingFlag:false,
            multipleSelection:[],
            tagNameTypeList:[
                {
                    name:'随访记录',
                    id:'1'
                },
                {
                    name:'问题问卷',
                    id:'2'
                },
                {
                    name:'评估量表',
                    id:'3'
                },
                {
                    name:'入案评估',
                    id:'4'
                },
            ],
            searchPatientData:{
                totalPage:0,
                listData:[],
                listQuery:{
                    redundant:'',//搜索内容
                    userType:'',//病人类型
                    diseaseType:'',//疾病类型
                    userFrom:'',//来源渠道
                    current: 1,
                    size: 10,
                }
            },//推送筛选条件
            diseaseTypeList:[],//疾病类型列表
            pushDiaog:false,//推送问卷弹窗


            dialogFormVisible:false,//新增加问卷开关
            paramData:{},//预览组件需要的参数

            TitleText:'动态',//预览问卷的动态title
            addForm:{//新增问卷提交参数
                title:'',//问卷名称
                subTitle:'',//副标题
                note:'',//备注、描述
                image:'',
                tagName:'',//问卷类型
            },
            formRules:{//新增问卷规则
                tagName:[
                    { required: true, message: '请选择问卷类型', trigger: 'change' }
                ],
                title: [
                    { 
                        required: true, 
                        message: '请输入问卷标题', 
                        trigger: 'blur' 
                    },
                    {
                        max: 25,
                        message: '25 个字符以内',
                        trigger: 'blur',
                    },
                ],
                subTitle:[
                    { 
                        required: true, 
                        message: '请输入问卷副标题', 
                        trigger: 'blur' 
                    },
                    {
                        max: 25,
                        message: '25 个字符以内',
                        trigger: 'blur',
                    },
                ],
                note:[
                    { 
                        required: true, 
                        message: '请添加问卷说明', 
                        trigger: 'blur' 
                    }
                ]
            },
            homeTableQuerr:{//table 查询数据
                totalPage:0,
                listData:[],
                listQuery:{
                    size:10,
                    current:1,
                }
            }
        }
    },
    created(){
        this.init();
        this.getDiseaseType();
        this.searchPatientHandel();
    },
    methods:{
        /**
         * @description: 背景图片上传
         * @param {*} response
         * @param {*} file
         * @param {*} fileList
         * @return {*}
         */
        handleBackgroundResponse(response) {
            if (response.code == 0) {
                return this.addForm.image = `${process.env.VUE_APP_OSS_URL}`+response.data
            }
        },
        /**
         * @description: 病人选择分页
         * @param {*}
         * @return {*}
         */
        queryPushList(){
            this.searchPatientHandel();
        },
        /**
         * @description: 病人选择checkout
         * @param {*}
         * @return {*}
         */
        pushListChange(val){
            this.multipleSelection = val;
        },
        /**
         * @description: 推送
         * @param {*}
         * @return {*}
         */
        qushSearchPatient(){
            this.loadingFlag = true;
            const patientIds = this.multipleSelection.map(item=>item.patientId);
            pushIm({
                examId:this.examId.id,
                patientIds:patientIds
            }).then(res=>{
                if(res.code == 0 ){
                    this.$message.success('推送成功')
                    this.multipleSelection = [];
                    this.loadingFlag = false;
                    this.pushDiaog = false;
                }
            })
        },
        /**
         * @description: 推送病人列表分页条件查询
         * @param {*}
         * @return {*}
         */
        searchPatientHandel(){
            searchPatient(
                this.searchPatientData.listQuery,
            ).then(res=>{
                if(res.code == 0){
                    this.searchPatientData.listData = res.data.records;
                    this.searchPatientData.totalPage = res.data.total;
                }
            })
        },
         /**
         * @description: 病种类型
         * @event:
         * @param {*}
         * @return {*}
         *
         */
        getDiseaseType() {
            diseaseType().then((res) => {
                if (res.code == 0) {
                    this.diseaseTypeList = res.data
                }
            })
        },
        /**
         * @description: 重置
         * @param {*}
         * @return {*}
         */
        resetquerySearchPatient(){
            this.searchPatientData.listQuery = this.$options.data().searchPatientData.listQuery
            searchPatient(
                this.searchPatientData.listQuery,
            ).then(res=>{
                if(res.code == 0){
                    this.searchPatientData.listData = res.data.records;
                    this.searchPatientData.totalPage = res.data.total;
                }
            })
        },
        /**
         * @description: 病人选择 查询
         * @param {*}
         * @return {*}
         */
        querySearchPatient(){
            this.searchPatientData.listQuery.size = 10;
            this.searchPatientData.listQuery.current = 1;
            this.searchPatientHandel();
        },

        /**
         * @description: 关闭病人选择弹窗
         * @param {*}
         * @return {*}
         */
        closePushDiaog(){

        },
        
        /**
         * @description: 推送功能
         * @param {*}
         * @return {*}
         */
        pushbatchs(){
        },
        /**
         * @description: 调用子级组件方法
         * @param {*}查询详情接口
         * @return {*}
         */
        previewVisible(scope){
            selectListExam({
                examId:scope.id,
            }).then(res=>{
                if(res.code == 0 ){
                    this.paramData = res.data;
                    this.$refs.dialogRef.showVisible()
                }else{
                    this.$message({
                        type:'error',
                        message:res.message
                    })
                }
            })
        },

        /**
         * @description: 查询列表数据
         * @param {*}
         * @return {*}
         */
        init(){
            list( this.homeTableQuerr.listQuery).then(res=>{
                if(res.code == 0 ){
                    this.homeTableQuerr.listData = res.data.records;
                    this.homeTableQuerr.totalPage = res.data.total
                }
            })
        },
        
        /**
         * @description: //点击发布按钮，弹窗出现
         * @param {*}
         * @return {*}
         */
        showIssue(scope){
            passQuestion( {
                examId:scope.id,
                flag:!scope.passed
            } ).then(res=>{
                if(res.code  == 0 ){
                    this.init()
                    this.$message.success(res.message)
                }else{
                    this.$message.error(res.message)
                }
            })
        },

        /**
         * @description: 关闭问卷弹窗
         * @param {*}
         * @return {*}
         */
        closeissue(){

        },

        /**
         * @description: 发布问卷
         * @param {*}
         * @return {*}
         */
        issue(){

        },
     
        /**
         * @description: 首页table表格分页查询
         * @param {*}
         * @return {*}
         */    
        paginationChange(){
            this.init()
        },

        /**
         * @description: 创建问卷 成功后返回该问卷的id，拿到id调转新页面进行查询
         * @param {*}
         * @return {*}
         */    
        addNew(){
            this.$refs['forms'].validate((valid) => {
                if (valid) {
                    if(!this.addForm.image) return this.$message.error('请上传问卷封面背景图');
                    this.addForm.image = this.addForm.image.substring(process.env.VUE_APP_OSS_URL.length)
                    addExam({
                        ...this.addForm,
                        name:this.addForm.title
                    }).then(res=>{
                        if(res.code == 0 ){
                            this.$router.push({
                                path:'/addQuestion',
                                query:{
                                    id:res.data.id
                                }
                            })
                        }
                    })
                } 
            });
        }
    }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>